const defaultNodeCellSize = 96;
export const defaultMargins = 8;

export const defaultNodeSize = {
  square: { width: defaultNodeCellSize, height: defaultNodeCellSize },
  wide: { width: defaultNodeCellSize * 2, height: defaultNodeCellSize },
  tall: {
    width: (defaultNodeCellSize * 12) / 9,
    height: defaultNodeCellSize * 2,
  },
};

export const defaultImageSize = {
  square: {
    width: defaultNodeCellSize - defaultMargins * 2,
    height: defaultNodeCellSize - defaultMargins * 2,
  },
  wide: {
    width: defaultNodeCellSize * 2 - defaultMargins * 2,
    height: defaultNodeCellSize - defaultMargins * 2,
  },
  tall: {
    width: defaultNodeCellSize * 1.5 - defaultMargins * 2,
    height: defaultNodeCellSize * 2 - defaultMargins * 2,
  },
};

export type Size = { width: number; height: number };

export type Options = {
  nodeSize?: Size;
  imageSize?: Size;
  imageMargin?: number;
};
